module.exports = __webpack_public_path__ + "img/pending.36cd1ac0.svg";